// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumb-bar-container[data-v-0046711a] {\n  left: 200px;\n  max-width: calc(100% - 200px);\n  height: 72px;\n}\n.mobile .breadcrumb-bar-container[data-v-0046711a] {\n  left: 50px;\n  max-width: calc(100% - 50px);\n  height: 50px;\n}", ""]);
// Exports
module.exports = exports;
